export const dayOfWeekFields = [
  ['Domingo', 'hourStartWeekSun', 'hourEndWeekSun'],
  ['Segunda', 'hourStartWeekMon', 'hourEndWeekMon'],
  ['Terça', 'hourStartWeekTue', 'hourEndWeekTue'],
  ['Quarta', 'hourStartWeekWed', 'hourEndWeekWed'],
  ['Quinta', 'hourStartWeekThu', 'hourEndWeekThu'],
  ['Sexta', 'hourStartWeekFri', 'hourEndWeekFri'],
  ['Sábado', 'hourStartWeekSat', 'hourEndWeekSat']
];

export const INITIAL_VALUES_INPUT_MASK = {
  hourStartWeekSun: '00:00',
  hourEndWeekSun: '00:00',
  hourStartWeekMon: '00:00',
  hourEndWeekMon: '00:00',
  hourStartWeekTue: '00:00',
  hourEndWeekTue: '00:00',
  hourStartWeekWed: '00:00',
  hourEndWeekWed: '00:00',
  hourStartWeekThu: '00:00',
  hourEndWeekThu: '00:00',
  hourStartWeekFri: '00:00',
  hourEndWeekFri: '00:00',
  hourStartWeekSat: '00:00',
  hourEndWeekSat: '00:00'
};

export const hourTransform = value => {
  const hour = String(value);
  let hr = '';
  const qtdDigits = hour.length;
  switch (qtdDigits) {
    case 1:
      hr = '000' + hour;
      break;
    case 2:
      hr = '00' + hour;
      break;
    case 3:
      hr = '0' + hour;
      break;
    default:
      hr = hour;
      break;
  }
  return hr.length === 4
    ? `${hr.charAt(0)}${hr.charAt(1)}:${hr.charAt(2)}${hr.charAt(3)}`
    : '';
};

export const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

export const dateRegex = /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
